// extracted by mini-css-extract-plugin
export default {"viewerframe":"Pg_2_3_viewerframe__+oV1T","content":"Pg_2_3_content__5s0YZ"};